import { render, staticRenderFns } from "./TarjetaConstancia.vue?vue&type=template&id=4d2a4ac9&scoped=true&"
import script from "./TarjetaConstancia.vue?vue&type=script&lang=js&"
export * from "./TarjetaConstancia.vue?vue&type=script&lang=js&"
import style0 from "./TarjetaConstancia.vue?vue&type=style&index=0&id=4d2a4ac9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2a4ac9",
  null
  
)

export default component.exports